import { render, staticRenderFns } from "./CompanyLpProduct.vue?vue&type=template&id=309fc39f&scoped=true"
import script from "./CompanyLpProduct.vue?vue&type=script&lang=js"
export * from "./CompanyLpProduct.vue?vue&type=script&lang=js"
import style0 from "./CompanyLpProduct.vue?vue&type=style&index=0&id=309fc39f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309fc39f",
  null
  
)

export default component.exports